import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastNotificationsContainerComponent } from "./notifications/components/elements/toast-notifications-container/toast-notifications-container.component";
import { SidebarComponent } from './shared/navigation/sidebar/sidebar.component';
import { NavbarComponent } from './shared/navigation/navbar/navbar.component';
import { DynamicRouterService } from './shared/services/dynamic-router.service';
import { GoogleMapsLoaderService } from './shared/map/services/google-maps-loader.service';
import { filter } from 'rxjs';
import { AuthService } from './modules/auth/services/auth.service';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, SidebarComponent, NavbarComponent, ToastNotificationsContainerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  title = 'cadouh_dashboard';

  router = inject(Router);

  minimizeSidebar = false;

  private authService = inject(AuthService);
  dynamicRouterService = inject(DynamicRouterService);

  notShowRoutes = ["/login", "/reset-password", "/reset-password-otp", "/new-password"];

  sidebarOpen = false;

  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
  }

  showBars() {
    // router.url carries query/fragment (e.g. "/login?passwordReset=success"),
    // so match against the path only.
    const path = this.router.url.split(/[?#]/)[0];
    return !this.notShowRoutes.includes(path) && this.authService.getTokenData()?.role !== "customer";
  };


  toggleMinimize($event: void) {
    this.minimizeSidebar = !this.minimizeSidebar;
  }

  constructor(private mapsLoader: GoogleMapsLoaderService) {}

  async ngOnInit(): Promise<void> {
    this.dynamicRouterService.updateRoutesBasedOnRole();
    await this.mapsLoader.load();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.sidebarOpen = false;
      });

    this.dynamicRouterService.updateRoutesBasedOnRole();
    this.mapsLoader.load();
  }
}
